import React from "react";
import PropTypes from "prop-types";
import MessageBanner, { TYPE_ERROR } from '../elements/banner/MessageBanner';

export default class PaymentCancelPopup extends React.PureComponent {
    onCloseCallback = () => {
        let { paymentCancelShown } = this.props;

        paymentCancelShown();
    };
    render() {
        let { isPaymentCancel } = this.props;

        if (!isPaymentCancel) {
            return false;
        }

        return <MessageBanner className={'payment-cancel-popup'} onCloseCallback={this.onCloseCallback} type={TYPE_ERROR}>Payment has been cancelled</MessageBanner>;
    }
}

PaymentCancelPopup.propTypes = {
    isPaymentCancel: PropTypes.bool.isRequired,
    paymentCancelShown: PropTypes.func.isRequired,
};
